import { StyledIcon } from '../Icon.Styled'
import type { IconProps } from '../Icon.Types'

export const SfChevronForwardIcon = (props: IconProps) => {
  return (
    <StyledIcon
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18.2242 11.9491C18.2178 11.5355 18.0684 11.1903 17.7347 10.8667L9.95878 3.2494C9.6931 2.99061 9.38052 2.8642 8.99854 2.8642C8.24469 2.8642 7.63104 3.46451 7.63104 4.22204C7.63104 4.59391 7.78365 4.93911 8.05805 5.21399L14.9776 11.9459L8.05805 18.6843C7.78687 18.956 7.63104 19.2975 7.63104 19.6795C7.63104 20.4338 8.24469 21.0373 8.99854 21.0373C9.37408 21.0373 9.6931 20.9109 9.95878 20.6453L17.7347 13.0316C18.0716 12.7011 18.2242 12.3596 18.2242 11.9491Z"
        fill="currentColor"
      />
    </StyledIcon>
  )
}
